import { contactBannerHTML, handleFreeShipping } from '../global'
import { _t, isMobile } from '../base'
import { moveCartElements } from "./cart";

export function initStep1() {
    if ($('.id--9').length) {
        step1ContentLoaded()

        document.addEventListener('ShoptetDOMCartContentLoaded', async function () {
            step1ContentLoaded()
            moveCartElements()
        })
    }
}

function step1ContentLoaded() {
    restructureCartLayout()
    giftWrapper()
    step1TextChanges()
    handleFreeShipping()
}

function step1TextChanges() {
    $('.discount-coupon .btn').text('Přidat')
}

// Přesouvá elementy do nového layoutu
function restructureCartLayout() {
    const priceSidebar = $('.cart-inner .summary .col-md-4')
    const cartTable = $('.cart-table')
    // const cart = getShoptetDataLayer('cart')

    priceSidebar.insertAfter(cartTable)

    cartTable.wrap("<div class='col-md-8'></div>")

    $('<h4>', { text: _t('cart.orderRecap') }).insertBefore('.price-wrapper');

    $('.row.summary').insertAfter(cartTable)
    // $('.row.summary').clone().insertBefore('.price-wrapper')

    // if (cart.length) {
    //     $('.col-md-4').append(contactBannerHTML(true))
    // }
}

// Pokud jsou v košíku dárky vytvoří se pro ně kontejner napozicovaný pod produkty
function giftWrapper() {
    const giftSelectors = [
        { selector: '.free-product-gifts li', class: 'gifts-item-1' },
        { selector: '[data-testid="wrapperOrderGift"]', class: 'gifts-item-2' },
        { selector: '[data-testid="selectGiftWrapper"]', class: 'gifts-item-2' },
    ]

    const hasGifts = giftSelectors.some(({ selector }) => $(selector).length)

    if (hasGifts) {
        $('.row.summary').prepend(`<div class="gift-wrapper"><h2>DOPLŇKY KE ZBOŽÍ</h2></div>`)

        giftSelectors.forEach(({ selector, class: className }) => {
            const gifts = $(selector)
            if (gifts.length) {
                const container = $(`<div class="${className}"></div>`).appendTo('.gift-wrapper')
                processGifts(gifts, container)
            }
        })
    }
}

function processGifts(gifts, container) {
    gifts.each(function () {
        const gift = $(this)
        const giftName = gift.find('.free-gift-name')

        addGiftLabel(giftName)
        gift.find('.free-gifts-img-hover').remove()

        if (gift.is('li')) {
            gift.appendTo(container)
        } else {
            gift.find('li').each(function () {
                addGiftLabel($(this).find('.free-gift-name'))
            })
            gift.appendTo(container)
        }
    })
}

function addGiftLabel(giftName) {
    giftName.text(giftName.text()).after(`<span class="product-is-gift">${_t('cart.step1.gift')}</span>`)
}
